import { render } from "./ruleModal.vue?vue&type=template&id=e1bbb576&scoped=true"
import script from "./ruleModal.vue?vue&type=script&lang=js"
export * from "./ruleModal.vue?vue&type=script&lang=js"

import "./ruleModal.vue?vue&type=style&index=0&id=e1bbb576&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1bbb576"]])

export default __exports__